import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import React from "react";

function ProjectIcon(props: SvgIconProps) {
  return (
    <SvgIcon height="16" viewBox="0 0 17 16" width="17" fill="none" {...props}>
      <path
        clipRule="evenodd"
        d="M15.8334 7.49936C15.8334 10.721 13.2217 13.3327 10 13.3327C9.94432 13.3327 9.88877 13.3319 9.83341 13.3304V13.3327H1.16675V11.9994H6.28796C4.9924 10.9294 4.16671 9.31082 4.16671 7.49936C4.16671 4.27769 6.77838 1.66602 10 1.66602C13.2217 1.66602 15.8334 4.27769 15.8334 7.49936ZM10.0001 10.9994C11.9331 10.9994 13.5001 9.43237 13.5001 7.49937C13.5001 5.56637 11.9331 3.99936 10.0001 3.99936C8.06706 3.99936 6.50005 5.56637 6.50005 7.49937C6.50005 9.43237 8.06706 10.9994 10.0001 10.9994Z"
        fill="#212121"
        fillRule="evenodd"
        transform="rotate(180,8.5,8)"
      />
    </SvgIcon>
  );
}

export default ProjectIcon;
